export default class Vod {
    
    
}


// WEBPACK FOOTER //
// ./src/Sdk/Vod.js